import { FC, PropsWithChildren, ReactNode, createContext, useContext, useState } from 'react';
import { DrawerSlot } from './DrawerSlot';
import { useDrawerStore } from './useDrawerStore';
import { MainDrawerPortals } from './portals';

export type DrawersContextData = {
  leftRef: HTMLDivElement | null;
  rightRef: HTMLDivElement | null;
};

const DrawerContext = createContext<DrawersContextData | null>(null);

type DrawerProviderProps = {
  marginTop?: number;
  children: ReactNode;
  AppBar: FC;
};

const DrawerLayout = ({ children }: PropsWithChildren) => {
  const storeLeftWidth = useDrawerStore((state) => state.left.width);
  const storeRightWidth = useDrawerStore((state) => state.right.width);
  return (
    <div
      className="grid h-screen overflow-hidden transition-all duration-300"
      style={{ gridTemplateColumns: `${storeLeftWidth || 0}px 1fr ${storeRightWidth || 0}px` }}
    >
      {children}
    </div>
  );
};

export const DrawerProvider = ({ children, marginTop, AppBar }: DrawerProviderProps) => {
  const [leftRef, setLeftRef] = useState<HTMLDivElement | null>(null);
  const [rightRef, setRightRef] = useState<HTMLDivElement | null>(null);

  return (
    <DrawerContext.Provider value={{ leftRef, rightRef }}>
      <AppBar />
      <DrawerLayout>
        <DrawerSlot className="group drawer-left" marginTop={marginTop} ref={setLeftRef} />
        <main
          className="main-content-container m-0 flex flex-col overflow-hidden bg-surface-primary p-0"
          style={{ marginTop }}
        >
          {children}
        </main>
        <DrawerSlot className="group drawer-right" marginTop={marginTop} ref={setRightRef} />
      </DrawerLayout>
      <MainDrawerPortals />
    </DrawerContext.Provider>
  );
};

export const useDrawer = () => {
  const context = useContext(DrawerContext);

  return context;
};
